import { LocationData } from '../types';
import { FACILITY_SAFETY } from '../constants';

export interface FacilitySafety {
  // Raw counts of placed equipment
  extinguishers: number;
  accessControl: number;   // tourniquet doors
  cabinets: number;
  bins: number;
  // Derived, capped reductions (0–1 fractions)
  coolingFailureReduction: number; // applied to cooling-failure event probability
  hardwareRecallReduction: number; // applied to hardware-recall event probability
  repairTimeReduction: number;     // applied to server repair time
  failureReduction: number;        // applied to baseline hardware failure probability
}

const EMPTY: FacilitySafety = {
  extinguishers: 0, accessControl: 0, cabinets: 0, bins: 0,
  coolingFailureReduction: 0, hardwareRecallReduction: 0,
  repairTimeReduction: 0, failureReduction: 0,
};

/** Count safety equipment on a location's site layout and derive its capped bonuses. */
export const computeFacilitySafety = (location: LocationData | null | undefined): FacilitySafety => {
  const cells = location?.siteLayout?.cells;
  if (!cells) return { ...EMPTY };

  let extinguishers = 0, accessControl = 0, cabinets = 0, bins = 0;
  for (const row of cells) {
    for (const cell of row) {
      switch (cell?.type) {
        case 'extinguisher': extinguishers++; break;
        case 'tourniquetDoor': accessControl++; break;
        case 'cabinet': cabinets++; break;
        case 'bin': bins++; break;
        default: break;
      }
    }
  }

  const f = FACILITY_SAFETY;
  return {
    extinguishers, accessControl, cabinets, bins,
    coolingFailureReduction: Math.min(f.extinguisherFireCap, extinguishers * f.extinguisherFirePerUnit),
    hardwareRecallReduction: Math.min(f.accessControlCap, accessControl * f.accessControlPerUnit),
    repairTimeReduction: Math.min(f.cabinetRepairCap, cabinets * f.cabinetRepairPerUnit),
    failureReduction: Math.min(f.binFailureCap, bins * f.binFailurePerUnit),
  };
};
